// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
}

#notfound {
  position: relative;
  height: 100vh;
}

#notfound .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.notfound {
  max-width: 920px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
}

.notfound .notfound-404 {
  position: absolute;
  height: 100px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}

.notfound .notfound-404 h1 {
  font-family: "Maven Pro", sans-serif;
  color: #ececec;
  font-weight: 900;
  font-size: 276px;
  margin: 0px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.notfound h2 {
  font-family: "Maven Pro", sans-serif;
  font-size: 46px;
  color: #000;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0px;
}

.notfound p {
  font-family: "Maven Pro", sans-serif;
  font-size: 16px;
  color: #000;
  font-weight: 400;
  text-transform: uppercase;
  margin-top: 15px;
}

.notfound a {
  font-family: "Maven Pro", sans-serif;
  font-size: 14px;
  text-decoration: none;
  text-transform: uppercase;
  background: #189cf0;
  display: inline-block;
  padding: 16px 38px;
  border: 2px solid transparent;
  border-radius: 40px;
  color: #fff;
  font-weight: 400;
  transition: 0.2s all;
}

.notfound a:hover {
  background-color: #fff;
  border-color: #189cf0;
  color: #189cf0;
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-404 h1 {
    font-size: 162px;
  }
  .notfound h2 {
    font-size: 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/404.css"],"names":[],"mappings":"AAAA;EAEE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAGR,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,SAAS;EAGT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAGR,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAEhB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n}\n\n#notfound {\n  position: relative;\n  height: 100vh;\n}\n\n#notfound .notfound {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.notfound {\n  max-width: 920px;\n  width: 100%;\n  line-height: 1.4;\n  text-align: center;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.notfound .notfound-404 {\n  position: absolute;\n  height: 100px;\n  top: 0;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  z-index: -1;\n}\n\n.notfound .notfound-404 h1 {\n  font-family: \"Maven Pro\", sans-serif;\n  color: #ececec;\n  font-weight: 900;\n  font-size: 276px;\n  margin: 0px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.notfound h2 {\n  font-family: \"Maven Pro\", sans-serif;\n  font-size: 46px;\n  color: #000;\n  font-weight: 900;\n  text-transform: uppercase;\n  margin: 0px;\n}\n\n.notfound p {\n  font-family: \"Maven Pro\", sans-serif;\n  font-size: 16px;\n  color: #000;\n  font-weight: 400;\n  text-transform: uppercase;\n  margin-top: 15px;\n}\n\n.notfound a {\n  font-family: \"Maven Pro\", sans-serif;\n  font-size: 14px;\n  text-decoration: none;\n  text-transform: uppercase;\n  background: #189cf0;\n  display: inline-block;\n  padding: 16px 38px;\n  border: 2px solid transparent;\n  border-radius: 40px;\n  color: #fff;\n  font-weight: 400;\n  -webkit-transition: 0.2s all;\n  transition: 0.2s all;\n}\n\n.notfound a:hover {\n  background-color: #fff;\n  border-color: #189cf0;\n  color: #189cf0;\n}\n\n@media only screen and (max-width: 480px) {\n  .notfound .notfound-404 h1 {\n    font-size: 162px;\n  }\n  .notfound h2 {\n    font-size: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
